import { inject } from '@angular/core';
import { CanActivateFn, Router } from '@angular/router';

import { environment } from '../../../environments/environment';

/**
 * When the platform is in beta mode (`environment.isBeta === true`), the
 * public `/register` page redirects to `/contact` unless the request
 * carries a `?beta` query param (any value). When `isBeta` is false, the
 * guard is a no-op and the `?beta` param is ignored.
 */
export const betaRegisterGuard: CanActivateFn = (route) => {
  if (!environment.isBeta) {
    return true;
  }

  const hasBetaParam = Object.prototype.hasOwnProperty.call(route.queryParams ?? {}, 'beta');
  if (hasBetaParam) {
    return true;
  }

  const router = inject(Router);
  return router.parseUrl('/contact?from=register');
};
